import type { ImageUrl } from '@/shared/types/ImageUrl';

/**
 * Returns the full URL for an asset. If the value is already an absolute URL,
 * it is returned as-is. Otherwise it is routed through the asset proxy.
 */
export const getAssetUrl = (path: string | null | undefined): string => {
  if (!path) return '';

  return path;
};

/**
 * Extract a usable image src from an ImageUrl object or legacy string.
 * Accepts an optional variant to pick a specific thumbnail size.
 */
export type ImageVariant = 'original' | 'preview' | 'search_result' | 'search';

export function resolveImageSrc(
  value: ImageUrl | string | null | undefined,
  variant: ImageVariant = 'original'
): string {
  if (!value) return '';

  // Legacy string support
  if (typeof value === 'string') return value;

  if (variant === 'original') return value.original;

  return value.thumbnails?.[variant] ?? value.original;
}
